import r, { api } from "modules/Request";
import CommonBox from "pages/commonBox/commonBox";
import HomePage from "pages/HomePage/HomePage";
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";

// 判断是否在微信环境
function isWeixinBrowser() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") !== -1;
}

const urlMap = {
  t: "https://cfp-t.vecarbon.com",
  u: "https://cfp-u.vecarbon.com",
  d: "https://cfp.vecarbon.com",
};

const disposeQrCodeUrl = () => {
  const url = window.location.origin;
  let qrUrl = "";
  if (url === "https://cfp-t.vecarbon.com") {
    qrUrl = urlMap.t;
  } else if (url === "https://cfp-u.vecarbon.com") {
    qrUrl = urlMap.u;
  } else {
    qrUrl = urlMap.d;
  }
  return qrUrl;
};
// Since routes are regular React components, they
// may be rendered anywhere in the app, including in
// child elements.
//
// This helps when it's time to code-split your app
// into multiple bundles because code-splitting a
// React Router app is the same as code-splitting
// any other React app.

export default function NestingExample() {
  //有些页面不调用
  const exceptionUrl = ["/batteryPassportCh", "/batteryPassportEn"];
  const getPathname = window.location.pathname;
  const history = useHistory();
  useEffect(() => {
    getWxConfig();
    /**
     * 50分钟获取需要重新获取
     */
    setInterval(() => {
      getWxConfig();
    }, 3000000);
  }, []);

  const getWxConfig = async () => {
    const url = window.location.href;
    const result = await r.get(`${api.GET_WX_CONFIG}`, {
      url: `${url}`,
    });
    if (result.status.code === "00000") {
      const data = result?.data || {};
      if (isWeixinBrowser()) {
        // eslint-disable-next-line no-undef
        wx?.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: "wxa7280767dce5cbcb", // 必填，公众号的唯一标识
          timestamp: data?.timeMillis, // 必填，生成签名的时间戳
          nonceStr: data?.noncestr, // 必填，生成签名的随机串
          signature: data?.jsKey, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });
      }
    }
  };
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={HomePage}>
            {/* <HomePage /> */}
            {/* {window.location.href.split('/')[3] === '' && history.push('/home')} */}
          </Route>
          <Route>
            <CommonBox />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
